import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { EntryScreen } from "./components/EntryScreen";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ApartmentPage from "./pages/ApartmentPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import LocationPage from "./pages/LocationPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";

function SimpleCookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const consent = window.localStorage.getItem("cookie-consent");
    if (!consent) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/80 text-white text-sm px-4 py-3 z-50">
      <div className="max-w-4xl mx-auto flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <span>
          Questo sito utilizza solo cookie tecnici necessari al suo funzionamento.
          Proseguendo la navigazione accetti l&apos;uso di questi cookie.
        </span>
        <button
          className="mt-2 sm:mt-0 bg-white text-black px-3 py-1 rounded"
          onClick={() => {
            window.localStorage.setItem("cookie-consent", "accepted");
            setVisible(false);
          }}
        >
          Ho capito
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EntryScreen />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/chi-siamo" element={<AboutPage />} />
            <Route path="/appartamento" element={<ApartmentPage />} />
            <Route path="/attivita" element={<ActivitiesPage />} />
            <Route path="/posizione" element={<LocationPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contatti" element={<ContactPage />} />
          </Routes>

          <SimpleCookieBanner />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}


export default App;
